import { ValidateNumberModel, validateADINumber, validateNumberParams } from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<validateNumberParams & HasOnSuccess, ValidateNumberModel>;

export const LoadValidationData: HandlerType = async (props: any) => {
    props.apiResult = await validateADINumber(props.parameter);
    props.parameter.onSuccess(props.apiResult);
};

export const chain = [LoadValidationData];

const adiValidateAdiNumber = createHandlerChainRunner(
    chain,
    "AdiValidateAdiNumber",
);
export default adiValidateAdiNumber;
